import { IsOptional, IsUUID, IsString, IsEnum } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

/**
 * Filtres pour les statistiques d'établissement
 */
export class EstablishmentStatsQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'année scolaire pour filtrer les enseignements' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Code niveau pour filtrer (ex: 6e, 5e, 2de)' })
  @IsOptional()
  @IsString()
  levelCode?: string

  @ApiPropertyOptional({ type: 'string', description: 'Code matière pour filtrer (ex: MATH, FR)' })
  @IsOptional()
  @IsString()
  subjectCode?: string
}

/**
 * Filtres pour les statistiques de charge d'enseignement
 */
export class TeachingLoadQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'année scolaire' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Code niveau pour filtrer' })
  @IsOptional()
  @IsString()
  levelCode?: string

  @ApiPropertyOptional({ type: 'string', description: 'Code matière pour filtrer' })
  @IsOptional()
  @IsString()
  subjectCode?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID d\'un enseignant spécifique' })
  @IsOptional()
  @IsString()
  teacherUserId?: string
}

/**
 * Filtres pour les statistiques globales
 */
export class GlobalStatsQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'année scolaire pour filtrer' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'établissement pour filtrer' })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string
}
